import http from '../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/store_invoicing`

export default (data) =>
  http.post(api, data)
